import {action} from "../index";
import {GET_USERS, USER_ERROR} from "../types";
import {apiCall} from "../../utils/apiCall";
import {getToken} from "../../helpers/tokenHelper";

export const getAllUsersAction = () => async (dispatch) => {
    try {
        const token = getToken();
        const headers = {
            Authorization: "Bearer ".concat(token),
        };
        const req = await apiCall.get('/intelligrapi/allusers', {
            headers,
        });
        dispatch(action(GET_USERS, req.data));
    } catch (e) {
        dispatch(action(USER_ERROR, e));
    }
    return false;
}

/**
 * Get all reps
 *
 * @returns {(function(*): Promise<void>)|*}
 */
export const getAllRepUsers = () => async dispatch => {
    try {
        const token = getToken();
        const headers = {
            Authorization: "Bearer ".concat(token),
        }
        const req = await apiCall.get('/intelligrapi/reps/allrepresentativeusers', {
            headers,
        });
        dispatch(action(GET_USERS, req.data));
    } catch (e) {
        dispatch(action(USER_ERROR, e.message));
    }
}

/**
 * Get representative users with pagination
 *
 * @param page - page number (0-indexed)
 * @param size - page size
 * @param status - optional status filter (active/inactive/suspended/all)
 * @returns {(function(*): Promise<void>)|*}
 */
export const getRepUsersPaginated = (page = 0, size = 25, status = null) => async (dispatch) => {
    try {
        const token = getToken();
        const headers = {
            Authorization: "Bearer ".concat(token),
        };
        
        let url = `/intelligrapi/reps/allrepresentativeusers?page=${page}&size=${size}`;
        if (status && status !== 'all') {
            url += `&status=${status}`;
        }
        
        const req = await apiCall.get(url, {
            headers,
        });
        dispatch(action(GET_USERS, req.data));
    } catch (e) {
        dispatch(action(USER_ERROR, e.message));
    }
}

/**
 * Get users with pagination
 *
 * @param page - page number (0-indexed)
 * @param size - page size
 * @param status - optional status filter (active/inactive/all)
 * @returns {(function(*): Promise<void>)|*}
 */
export const getUsersPaginated = (page = 0, size = 25, status = null) => async (dispatch) => {
    try {
        const token = getToken();
        const headers = {
            Authorization: "Bearer ".concat(token),
        };
        
        let url = `/intelligrapi/allusers?page=${page}&size=${size}`;
        if (status && status !== 'all') {
            url += `&status=${status}`;
        }
        
        const req = await apiCall.get(url, {
            headers,
        });
        dispatch(action(GET_USERS, req.data));
    } catch (e) {
        dispatch(action(USER_ERROR, e.message));
    }
}

export default getAllUsersAction;
